import React, { Component } from 'react'
import {
  Row, Col,
} from 'antd';
export default class Footer extends Component {
  render() {
    return (
        <div className='mi_footer'>

      <Row span={24} style={{width:"72vw",margin:"0px 0px 0px auto"}}>

        <Col span={8}>
          <div  >
              <h3 className='mi_pcolor'>MI Comp</h3>
              <p  className='mi_pcolor' style={{paddingRight:"107px"}}>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit tempore quam modi dolores ratione id, adipisci totam a quod eius, animi beatae culpa perspiciatis doloremque pariatur doloribus ipsa iure laborum?
              </p>
          </div></Col>
          <Col span={6}>
          <div  >
              <h3 className='mi_pcolor'>Quick Links</h3>
            <u> <p className='mi_color'> <a href="" className='mi_color'>About us</a></p></u>
            <u> <p className='mi_color'><a href="" className='mi_color'>How it Works</a></p></u>
            <u><p className='mi_color'><a href="" className='mi_color'>contact Us</a></p></u>
            <u> <p className='mi_color'><a href="" className='mi_color'>unsubscribe/Do not Sell My Info</a></p></u>
          </div></Col>
          <Col span={8}>
          <div  >
              <h3 className='mi_pcolor'>Legal</h3>
              <u className='mi_color'>  <p><a href="" className='mi_color'>Privacy Policy</a></p></u>
              <u className='mi_color'>  <p><a href="" className='mi_color'>Terms and Service</a></p></u>
          </div></Col>
      </Row>
      <Row style={{width:"850px",margin:'10px auto'}}>
      <hr ></hr>
<Row   className='mi_pcolor' style={{color:"black" ,margin:'0px auto',width:'420px'}}>
<i className="fa fa-copyright mi_pcolor" style={{margin:'0px auto'}}>
      <span className='mi_pcolor'> Copyrights reserved, 2021 by MI Comp - Agile Health</span>
      </i>
</Row>


      </Row></div>


    )
  }
}
